import React, { useEffect } from "react";
import "./App.css";
import { LanguageProvider } from "./context/LanguageContext";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Novidades from "./components/Novidades";
import Products from "./components/Products";
import CustomMix from "./components/CustomMix";
import Portfolio from "./components/Portfolio";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import CookieConsent from "./components/CookieConsent";
import { setupMetaPixelConsent } from "./lib/metaPixel";
import { setupGoogleAnalyticsConsent } from "./lib/googleAnalytics";
import WhatsAppButton from "./components/WhatsAppButton";

function App() {
  useEffect(() => {
    setupMetaPixelConsent();
    setupGoogleAnalyticsConsent();
  }, []);

  // Quem chega de fora com âncora (ex.: o botão "Pedir orçamento pelo site" das
  // páginas-guia manda para /#contact) tem de aterrar NA secção, não no topo.
  // O browser processa o #contact antes de o React montar a página, não encontra
  // nada com esse id, e desiste em silêncio. Por isso repetimos nós o salto
  // depois da montagem — e num rAF duplo, porque no primeiro as imagens ainda
  // não têm altura e o destino ainda não está no sítio certo.
  useEffect(() => {
    const id = window.location.hash.slice(1);
    if (!id) return;
    let cancelado = false;
    const saltar = () => {
      if (cancelado) return;
      const alvo = document.getElementById(id);
      if (alvo) alvo.scrollIntoView({ behavior: 'smooth' });
    };
    requestAnimationFrame(() => requestAnimationFrame(saltar));
    return () => { cancelado = true; };
  }, []);

  return (
    <LanguageProvider>
      <div className="App font-sans">
        <Header />
        <main>
          <Hero />
          <About />
          <Novidades />
          <Products />
          <CustomMix />
          <Portfolio />
          <Contact />
        </main>
        <Footer />
        <CookieConsent />
        <WhatsAppButton />
        <Toaster position="top-right" />
      </div>
    </LanguageProvider>
  );
}

export default App;
